export default function CharacterValidator(value : string) {
  const MAX_CHARACTER = 40;
  if(value.trim().length > MAX_CHARACTER){
    return `Character limit should be less than ${MAX_CHARACTER}`
  }
  return ""
}
